import type { GestureResponderEvent } from 'react-native'
import { Button, type IButtonProps } from '~/components/button'

import type { IconName } from '@raiadrogasil/pulso-icons'
import * as Comp from './bottom-sheets-right-button.styles'

interface BottomSheetsRightButtonProps extends Omit<IButtonProps, 'children'> {
  symbol?: IconName
}

export function BottomSheetsRightButton({
  onPress,
  testID,
  symbol,
  ...props
}: BottomSheetsRightButtonProps) {
  function handlePress(event: GestureResponderEvent) {
    onPress?.(event)
  }

  return (
    <Comp.RightButton>
      <Button.Root
        {...props}
        variant="neutral-tertiary"
        size="md"
        onPress={handlePress}
        testID={testID}
      >
        <Button.Icon symbol={symbol} />
      </Button.Root>
    </Comp.RightButton>
  )
}
